import { useState, useEffect, useCallback } from 'react';
import { apiClient } from '@/shared/services/apiClient';

export interface IncomingRequest {
  id: string;
  contractor_user_id: string;
  company_id: string;
  end_customer_id: string | null;
  first_name: string;
  last_name: string | null;
  phone_number: string;
  project: string | null;
  path_type: 'video' | 'schedule' | null;
  status: string;
  recording_request_id: string | null;
  calendar_event_id: string | null;
  room_id: string | null;
  scheduled_time: string | null;
  created_at: string;
  updated_at: string;
}

export function useIncomingRequests(options?: { enablePolling?: boolean }) {
  const [requests, setRequests] = useState<IncomingRequest[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchRequests = useCallback(async () => {
    try {
      setError(null);
      const response = await apiClient.get<{ ok: boolean; requests: IncomingRequest[] }>(
        API_ROUTES.INTAKE_REQUESTS
      );
      if (response.ok) {
        setRequests(response.requests);
      }
    } catch (err: any) {
      setError(err.message || 'Failed to load incoming requests');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchRequests();
  }, [fetchRequests]);

  useEffect(() => {
    if (!options?.enablePolling) return;
    const interval = setInterval(fetchRequests, 30000);
    return () => clearInterval(interval);
  }, [options?.enablePolling, fetchRequests]);

  return { requests, loading, error, refresh: fetchRequests };
}
